import {Service} from "@/apiServices/Service";

export class FirmaService extends Service {

    constructor() {
        super('firma/');
    }

    seleccionarArchivoBase64(dataURL, paciente, edicionExterna, hoy) {
        var blob = this.dataURLtoBlob(dataURL);


        const formData = new FormData();
        formData.append("firma", blob);
        formData.append("idPaciente", paciente);
        formData.append("hoy", hoy)

        if (!edicionExterna){
            formData.append("idUsuario", this.localStorage.getIdUsuario());
            return this.enviarArchivo(formData)
        } else {
            formData.append("idUsuario", 1);
            return this.enviarArchivoAbierto(formData)
        }

    }


    seleccionarArchivoBase64TUno(dataURL, hoy, paciente) {
        var blob = this.dataURLtoBlob(dataURL)


        const formData = new FormData();
        formData.append("firma", blob);
        formData.append("idPaciente", paciente);
        formData.append("hoy", hoy)
        formData.append("idUsuario", this.localStorage.getIdUsuario());
        return this.enviarArchivoTestUno(formData)


    }

    seleccionarArchivoBase64TDos(dataURL, hoy, paciente) {
        var blob = this.dataURLtoBlob(dataURL);


        const formData = new FormData();
        formData.append("firma", blob);
        formData.append("idPaciente", paciente);
        formData.append("hoy", hoy)
        formData.append("idUsuario", this.localStorage.getIdUsuario());
        return this.enviarArchivoTestDos(formData)


    }

    enviarArchivo(formData) {
        this.onStart();
        const config = {
            header: {
                "Content-Type": "image/png",
            },
        };
        return this.http.post(this.getUrl(['guardar']), formData, config)
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    enviarArchivoTestUno(formData) {
        return this.http.post(this.getUrl(['guardarFirmaTestigoUno']), formData)
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    enviarArchivoTestDos(formData) {
        return this.http.post(this.getUrl(['guardarFirmaTestigoDos']), formData)
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }




    enviarArchivoAbierto(formData) {
        this.onStart();
        const config = {
            header: {
                "Content-Type": "image/png",
            },
        };
        return this.http.post(this.getUrlBase(['guardar']), formData, config)
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    dataURLtoBlob(dataURL) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURL.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        //New Code
        return new Blob([ab], {type: mimeString});
    }

    getArchivoConBase64(params){
        return this.http.post(this.getUrl(['obtener','base64']), params)
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                // this.onError(e);
                console.error(e)
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    getArchivoConBase64Abierto(idPaciente){
        return this.http.get(this.getUrlBase(['obtener','base64'],{idPaciente}))
            .then((r) => this.onData(r))
            .then((r) => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


}
